export enum EFormTabId {
  MainInfo = '1',
  SellerAndProducts = '2',
  Documents = '3',
}
